import PricingPlans from './PricingPlans';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';

export default function EmailPricingPage() {
	const navigate = useNavigate();
	
	const handleGetStarted = () => {
		navigate('/request-for-services');
	};
	const emailPlans = [
		{
			tag: "For Getting Started",
			title: "Essentials",
			description: "Get the basics you need to start marketing your business.",
			buttonText: "Get Started",
			features: [
				"Post on Facebook, Instagram, Yelp, and Google",
				"Create and manage your business listings",
				"Access ideas and inspiration for your social media posts",
				"Get 10,000 monthly email sends"
			],
			recommended: false
		},
		{
			tag: "For boosting productivity",
			title: "Deluxe",
			description: "Boost your marketing efforts with robust tools that include digital ads.",
			buttonText: "Get Started",
			features: [
				"Design a custom logo that fits your brand",
				"Gain insights about your digital marketing plan — view what's working",
				"See what's happening next with a full visual view of your marketing calendar",
				"Get 120,000 monthly email sends"
			],
			recommended: true
		},
		{
			tag: "For collaboration & flexibility",
			title: "Ultimate",
			description: "Maximize your growth with full access to powerful marketing tools.",
			buttonText: "Get Started",
			features: [
				"Create your digital ads, content, and social posts",
				"Get 750,000 monthly email sends",
				"50,000 customer contacts for maximum reach",
				"Create unlimited branded images and videos"
			],
			recommended: false
		}
	];

	return (
		<>
			<div className=' bg-[#1a1a1a]'>
				<PricingPlans 
					title="For every business, a plan for success."
					plans={emailPlans}
				/>
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					transition={{ delay: 0.6 }}
					className="text-center pt-8"
				>
				<motion.button
					whileHover={{ scale: 1.05 }}
					whileTap={{ scale: 0.95 }}
					onClick={handleGetStarted}
					className="group inline-flex items-center justify-center gap-2 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg shadow-purple-500/25 hover:shadow-purple-500/40"
				>
					Get Started Today
					{/* <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" /> */}
				</motion.button>
				<p className="text-gray-300 mt-6">
					Start growing your business with the perfect plan
				</p>
			</motion.div>
			</div>
		</>
	);
}